<script>
  import { onMount, createEventDispatcher } from "svelte";
  
  const dispatch = createEventDispatcher();
  const defaultItem = { "code": "", "currency": "", "value": "", "country": "", "amount": "1"
    //freshness_minutes
  }
  const top_codes = {"EUR": true, "HRK": true, "HUF": true, "PLN": true, "CHF": true, "USD": true, "GBP": true}
  export let form_id = 'b6dbbf7c-8534-4ae8-9a47-d48fa0af4d66';
  
  let currencies = [];
  let top_currencies = [];
  let natural95 = null;
  let diesel = null;
  let el_min = null, el_max = null;
  let gas_min = null, gas_max = null;
  
  let visible_all = false;
  
  
  function toggleVisibility() {
    visible_all = !visible_all
  }
  
  onMount(getItems);
  
  function getItems() {
      fetch(`/data/${form_id}/data.json`)
      .then(function(r) {
        if (r.ok) return r;
        throw Error(r.statusText);
      })
      .then(r => r.json())
      .then(r => {
          currencies = [];
          for(var i in r.data.currencies) {
            if (r.data.currencies[i]["code"] in top_codes)
              top_currencies.push(Object.assign({}, defaultItem, r.data.currencies[i]));
            else
              currencies.push(Object.assign({}, defaultItem, r.data.currencies[i]));
          }
          currencies = currencies;
          top_currencies = top_currencies;
  
          natural95 = r.data.natural95;
          diesel = r.data.diesel;
          el_min = r.data.el_min;
          el_max = r.data.el_max;
          gas_min = r.data.gas_min;
          gas_max = r.data.gas_max;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
</script>
<div class='row'>
<div class='col-12 col-md-6 mx-auto'>
{#if natural95}
<div class='toast'>
<div class='toast-header d-flex justify-content-between bg-light'>
<span>
<i class='fa fa-gas-pump'></i>
Natural 95
</span>
<span class='text-secondary'>
{natural95} Kč/l
</span>
</div>
</div>
{/if}
{#if diesel}
<div class='toast'>
<div class='toast-header d-flex justify-content-between bg-light'>
<span>
<i class='fa fa-gas-pump'></i>
Nafta
</span>
<span class='text-secondary'>
{diesel} Kč/l
</span>
</div>
</div>
{/if}
{#if el_min && el_max}
<div class='toast'>
<div class='toast-header d-flex justify-content-between bg-light'>
<span>
<i class='fa fa-plug'></i>
D02d
</span>
<span class='text-secondary'>
{el_min} - {el_max} Kč/kWh
</span>
</div>
</div>
{/if}
{#if gas_min && gas_max}
<div class='toast'>
<div class='toast-header d-flex justify-content-between bg-light'>
<span>
<i class='fa fa-burn'></i>
Plyn
</span>
<span class='text-secondary'>
{gas_min} - {gas_max} Kč/m<sup>3</sup>
</span>
</div>
</div>
{/if}
</div>
<div class='col-12 col-md-6'>
<div class='mt-2 mx-1 shadow-sm'>
<table class='table m-0 text-muted'>
{#each top_currencies as item}
<tr class='toast bg-light'>
<td class='text-right pr-1' style='width:auto'>
{item.amount}
</td>
<td>
{item.code}
</td>
<td>{item.value}</td>
</tr>
{/each}
</table>
<button class='btn btn-link btn-block bg-light my-1' on:click='{toggleVisibility}' on:keyup='{toggleVisibility}'>
<i class='fa fa-angle-double-down'></i>
</button>
{#if visible_all}
<table class='table m-0 text-muted'>
{#each currencies as item}
<tr class='toast bg-light'>
<td class='text-right pr-1' style='width:auto'>
{item.amount}
</td>
<td>
{item.code}
</td>
<td>{item.value}</td>
</tr>
{/each}
</table>
{/if}
</div>
</div>
</div>
